import { Component, OnInit } from '@angular/core';
import { CashClosingDetail } from '../../../models/ComponentModels';

@Component({
  selector: 'app-cash-closing-details',
  templateUrl: './cash-closing-details.component.html',
  styleUrls: ['./cash-closing-details.component.scss']
})
export class CashClosingDetailsComponent implements OnInit {

  detail: CashClosingDetail;

  collapse: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
